import { Routes, AppServices, AppControllers } from './helpers/config_keys';

let AppRoutes = ($stateProvider: any,
    $urlRouterProvider: angular.ui.IUrlRouterProvider,
    $httpProvider: angular.IHttpProvider,
    $locationProvider: angular.ILocationProvider) => {
    $stateProvider
        .state(Routes.Login, {
            url: '/login',
            template: require('./authentication/login.html'),
            controller: AppControllers.LoginCtrl,
            controllerAs: 'loginVm',
            menu: '',
            authorize: false,
            permission: ''
        })
        .state(Routes.UnAuthorized, {
            url: '/unauthorized',
            template: require('./authentication/unauthorized.html'),
            menu: '',
            authorize: false,
            permission: ''
        })
        .state(Routes.ChangePassword, {
            url: '/changePassword',
            template: require('./user_profile/change_password.html'),
            controller: AppControllers.UserProfileCtrl,
            controllerAs: 'profileVm',
            menu: 'changePassword',
            authorize: true,
            permission: ''
        })
        .state(Routes.TopUpRequest, {
            url: '/topuprequest/:apikey',
            template: require('./topup/request.html'),
            controller: AppControllers.TopUpRequestCtrl,
            controllerAs: 'requestVm',
            menu: 'request',
            authorize: false,
            permission: ''
        })
        .state(Routes.TopUpPayment, {
            url: '/topuppayment/:status/:transac_id/:cust_ref/:pay_token',
            template: require('./topup/payment.html'),
            controller: AppControllers.TopUpPaymentCtrl,
            controllerAs: 'paymentVm',
            menu: 'payment',
            authorize: false,
            permission: ''
        })
        .state(Routes.Dashboard, {
            url: '/dashboard',
            template: require('./main/dashboard.html'),
            controller: AppControllers.DashboardCtrl,
            controllerAs: 'dashboardVm',
            menu: 'dashboard',
            authorize: true,
            permission: ''
        })
        .state(Routes.Reports, {
            url: '/reports',
            template: require('./reports/reports.html'),
            controller: AppControllers.ReportsCtrl,
            controllerAs: 'reportsVm',
            menu: 'reports',
            authorize: true,
            permission: ''
        })
        .state(Routes.ReportViewer, {
            url: '/report/:reportName',
            template: require('./reports/report_viewer.html'),
            controller: AppControllers.ReportViewerCtrl,
            controllerAs: 'rptViewerVm',
            menu: 'reports',
            authorize: true,
            permission: 'Report'
        })
        .state(Routes.Roles, {
            url: '/roles',
            template: require('./admin/roles.html'),
            controller: AppControllers.RolesCtrl,
            controllerAs: 'rolesVm',
            menu: 'admin.users',
            authorize: true,
            permission: ''
        })
        .state(Routes.Address, {
            url: '/address',
            template: require('./address/address.html'),
            menu: 'address.contacts',
            authorize: true,
            permission: ''
        })
        .state(Routes.Contacts, {
            url: '/contacts',
            template: require('./address/contacts.html'),
            controller: AppControllers.ContactsCtrl,
            controllerAs: 'contactsVm',
            menu: 'address.contacts',
            authorize: true,
            permission: ''
        })
        .state(Routes.MessagePortal, {
            url: '/messageportal',
            template: require('./messenger/message_portal.html'),
            controller: AppControllers.MessagePortalCtrl,
            controllerAs: 'portalVm',
            menu: 'messageportal',
            authorize: true,
            permission: ''
        })
        .state(Routes.Groups, {
            url: '/groups',
            template: require('./address/groups.html'),
            controller: AppControllers.GroupsCtrl,
            controllerAs: 'groupsVm',
            menu: 'address.contacts',
            authorize: true,
            permission: ''
        })

    $locationProvider.hashPrefix('');
    $urlRouterProvider.otherwise(Routes.Dashboard);
    $httpProvider.interceptors.push(AppServices.RequestInterceptor)
}
AppRoutes.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider', '$locationProvider']
export { AppRoutes }


// WEBPACK FOOTER //
// ./app/app_routes.ts